module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan1-1-a98a037d065bc5110b627a33bd5741b4.webp";